import { useState } from 'react';
import styles from './Documents.module.css';
import {AIHelpers} from '../../../components/DocumentTabs/AIHelpers/AIHelpers';
import {Personals} from '../../../components/DocumentTabs/Personals/Personals';
import {Templates} from '../../../components/DocumentTabs/Temlates/Templates';
import {Organizations} from '../../../components/DocumentTabs/Organizations/Organizations';
import {SurfaceBar} from '../../../components/SurfaceBar/SurfaceBar';


export function Documents() {
	const [activeTab, setActiveTab] = useState('tab1');

	const tabs = [
		{ id: 'tab1', label: 'AI помощник', component: <AIHelpers /> },
		{ id: 'tab2', label: 'Персональные', component: <Personals /> },
		{ id: 'tab3', label: 'Для организации', component: <Organizations /> },
		{ id: 'tab4', label: 'Шаблоны', component: <Templates /> }

	];

	const activeComponent = tabs.find(tab => tab.id === activeTab)?.component;

	return (
		<div className={styles.tabsWrapper}>
			<SurfaceBar
				tabs={tabs.map(({id, label}) => ({id, label}))}
				activeTab={activeTab}
				onTabChange={setActiveTab}
			/>

			<div className={styles.tabContent}>{activeComponent}</div>
		</div>
	);
}
